import React, { useEffect, useState, useCallback } from "react";
import RideCard from "./RideCard";
import { searchRides } from "../utils/api"; 
import AdBanner from "./ads/AdBanner";

export default function RideResults({ filters, user }) {
  const [rides, setRides] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchExactMatches = useCallback(async () => {
    if (!filters.from || !filters.to) {
      setRides([]);
      return;
    }

    try {
      setLoading(true);
      const data = await searchRides(filters);
      
      // ✅ THE FIX: Filter and Sort logic
      const activeRides = (data || [])
        .filter(ride => {
          const rideDate = new Date(ride.date);
          const today = new Date();
          today.setHours(0, 0, 0, 0); // Compare only the date, not time

          const isCancelled = ride.status === 'cancelled';
          const isCompleted = ride.completed === true || ride.status === 'completed';
          const isPast = rideDate < today;

          // Only keep rides that are NOT cancelled, NOT completed, and NOT in the past
          return !isCancelled && !isCompleted && !isPast;
        })
        .sort((a, b) => {
          // ✅ SORT: Newest posted rides first (like other websites)
          return new Date(b.createdAt || 0) - new Date(a.createdAt || 0);
        });

      setRides(activeRides);
    } catch (error) {
      console.error("Search Error:", error);
      setRides([]);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    fetchExactMatches();
  }, [fetchExactMatches]);

  return (
    <section className="results-section" style={{ marginTop: 32 }}>
      <h2 style={{ marginBottom: 16, fontSize: '1.2rem', fontWeight: '700' }}>
        🚗 Exact matches from <span style={{color: 'var(--primary)'}}>{filters.from}</span> to <span>{filters.to}</span>
      </h2>

      {loading ? (
        <div className="card loading-state">
          <p>Searching for the best rides...</p>
        </div>
      ) : rides.length === 0 ? (
        <div className="card empty-state" style={{ textAlign: 'center', padding: '40px' }}>
          <p style={{ color: "#64748b" }}>No active rides found for this route.</p>
          <span style={{ fontSize: '0.8rem', color: '#94a3b8' }}>Cancelled or past rides have been filtered out.</span>
        </div>
      ) : (
        <div className="grid grid-2">
          {rides.map((ride, index) => (
            <React.Fragment key={`${ride._id}-${index}`}>
              <RideCard ride={ride} user={user} matchType="exact" />

              {/* INJECT AD AFTER EVERY 4 RIDES */}
              {(index + 1) % 4 === 0 && (
                <div style={{ gridColumn: "1 / -1", margin: "10px 0", display: "flex", flexDirection: "column", alignItems: "center" }}>
                  <span style={{ fontSize: "10px", color: "#94a3b8", fontWeight: "700", textTransform: "uppercase", marginBottom: "4px", alignSelf: "flex-start" }}>
                    Sponsored
                  </span>
                  <AdBanner type="inline" />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      )}
    </section>
  );
}